import React from 'react';
import MultiSelect from '../MultiSelect';
import { useOrderDispatcherOptions } from '../../hooks/useDispatcherOptions';

interface OrderDispatcherFilterProps {
  value: string[];
  onChange: (value: string[]) => void;
  className?: string;
}

/**
 * Order Dispatcher filter component with built-in data fetching
 * Wraps MultiSelect with standard dispatcher filter configuration
 */
const OrderDispatcherFilter: React.FC<OrderDispatcherFilterProps> = ({
  value,
  onChange,
  className = 'min-w-[160px]',
}) => {
  const { options, loading } = useOrderDispatcherOptions();

  return (
    <MultiSelect
      options={options}
      value={value}
      onChange={onChange}
      placeholder={loading ? 'Loading...' : 'Order Dispatcher'}
      showClearOption={true}
      clearOptionLabel="All Order Dispatchers"
      enableSearch={true}
      searchPlaceholder="Search order dispatchers..."
      size="sm"
      className={className}
      disabled={loading}
      preserveOrder={true}
    />
  );
};

export default OrderDispatcherFilter;
